import React from "react";
import { NavLink } from "react-router-dom";
import qs from 'query-string';

function NnSongMenuLink({songId, children, skin='tech', timing, letters}) {
  const opts = {skin: skin.toLowerCase()};
  const pathname = `/song/${songId}`;
  let search = qs.stringify(opts);

  if (timing) {
     search += '&timing';
  }
  if (letters) {
    search += '&letters';
  }
  return (
    <NavLink
      className="nav-link"
      to={`${pathname}?${search}`}
    >{children}</NavLink>
  );
}

export default NnSongMenuLink;

/*
import React from "react";
import { NavLink } from "react-router-dom";
import qs from 'query-string';

function NnSongMenuLink({songId, children, skin='tech', timing, letters}) {
  const opts = {skin: skin.toLowerCase()};
  const pathname = `/song/${songId}`;
  let search = qs.stringify(opts);
  if (timing) {
     search += '&timing';
  }
  if (letters) {
    search += '&letters';
  }
  return (
    <NavLink
      className="nav-link"
      to={`${pathname}?${search}`}
    >{children}</NavLink>
  );
}

export default NnSongMenuLink;
*/